import { LwApiPM } from "@techniaorg/liteweb-api";
import { LwResult } from "@techniaorg/liteweb-api/dist/types/lw-public-api";
import { modelPathOnServer, waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_open() {
  LwAPI?.openModel(modelPathOnServer + "Flange.jt").then((result: LwResult) => {
    console.log(result);
  });
}

function ex_close() {
  LwAPI?.closeModel(modelPathOnServer + "Flange.jt").then(
    (result: LwResult) => {
      console.log(result);
    }
  );
}

// Bind functions to buttons
document.getElementById("open")?.addEventListener("click", async () => {
  await apiReady;
  ex_open();
});
document.getElementById("close")?.addEventListener("click", async () => {
  await apiReady;
  ex_close();
});
